<template>
  <div>
    <Transition name="load">
      <div id="loading" v-if="!loadend">
        <div class="svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 252.12 134.41"><path class="cls-2" d="M126.91,37.56c1.18,0,2.29.15,3.35.44,1.06.29,1.98.74,2.77,1.35.79.6,1.42,1.38,1.89,2.33.47.95.7,2.07.7,3.36,0,1.82-.47,3.4-1.4,4.74-.93,1.34-2.33,2.2-4.17,2.57v.08c.94.13,1.72.38,2.34.74.62.36,1.12.82,1.51,1.38.39.56.67,1.21.85,1.95.18.73.29,1.53.34,2.39.03.48.06,1.07.08,1.76.03.7.08,1.4.16,2.11.08.71.21,1.38.38,2.01.17.63.41,1.12.7,1.46h-3.02c-.16-.27-.29-.6-.38-.98-.1-.39-.16-.79-.2-1.2-.04-.41-.07-.82-.1-1.22-.03-.4-.05-.75-.08-1.04-.05-1.02-.14-2.03-.26-3.03-.12-1-.37-1.9-.76-2.69-.39-.79-.95-1.42-1.68-1.9-.74-.48-1.74-.7-3.03-.64h-10.35v12.71h-2.74v-28.68h13.12ZM126.71,51.17c.83,0,1.62-.13,2.37-.38s1.4-.62,1.96-1.1c.56-.48,1.01-1.06,1.34-1.74.34-.68.5-1.46.5-2.35,0-1.76-.51-3.15-1.52-4.17-1.02-1.01-2.57-1.52-4.65-1.52h-10.18v11.27h10.18Z"/><path class="cls-2" d="M152.99,45.79c1.22.59,2.24,1.38,3.07,2.37.83.99,1.46,2.15,1.88,3.47.43,1.33.64,2.74.64,4.23s-.21,2.91-.64,4.23c-.43,1.32-1.05,2.48-1.88,3.47-.83.99-1.85,1.77-3.07,2.35-1.22.58-2.61.86-4.19.86s-2.97-.29-4.19-.86c-1.21-.58-2.24-1.36-3.06-2.35-.83-.99-1.46-2.15-1.88-3.47-.43-1.32-.64-2.74-.64-4.23s.21-2.91.64-4.23c.43-1.32,1.06-2.48,1.88-3.47.83-.99,1.85-1.78,3.06-2.37,1.22-.59,2.61-.88,4.19-.88s2.97.29,4.19.88M145.65,47.79c-.91.51-1.66,1.18-2.26,2.01-.6.83-1.05,1.78-1.36,2.83-.31,1.06-.46,2.14-.46,3.24s.15,2.18.46,3.23c.31,1.06.76,2,1.36,2.83.6.83,1.35,1.5,2.26,2.01.9.51,1.96.76,3.16.76s2.25-.25,3.16-.76c.91-.51,1.66-1.18,2.26-2.01.6-.83,1.05-1.77,1.36-2.83.31-1.06.46-2.13.46-3.23s-.15-2.18-.46-3.24c-.31-1.06-.76-2-1.36-2.83-.6-.83-1.35-1.5-2.26-2.01-.91-.51-1.96-.76-3.16-.76s-2.25.26-3.16.76"/><polygon class="cls-2" points="164.9 37.56 164.9 55.55 176.38 45.51 179.75 45.51 170.92 53.18 180.35 66.23 177.18 66.23 168.99 54.95 164.9 58.36 164.9 66.23 162.35 66.23 162.35 37.56 164.9 37.56"/><path class="cls-2" d="M196.89,66.22v-3.73s-.08,0-.08,0c-.67,1.39-1.64,2.45-2.91,3.19-1.27.73-2.69,1.1-4.24,1.1-1.31,0-2.43-.18-3.36-.54-.93-.36-1.68-.87-2.25-1.54-.58-.67-1-1.48-1.27-2.45-.27-.96-.4-2.06-.4-3.29v-13.43h2.54v13.48c.05,1.87.49,3.29,1.3,4.25.82.96,2.23,1.45,4.24,1.45,1.1,0,2.03-.23,2.81-.7.77-.47,1.42-1.09,1.93-1.87.51-.77.89-1.66,1.13-2.67.24-1,.36-2.02.36-3.07v-10.87h2.54v20.68h-2.35Z"/><path class="cls-2" d="M204.35,45.54l6.82,17.66,6.38-17.66h2.53l-8.99,23.83c-.37.88-.72,1.61-1.04,2.18-.32.57-.68,1.03-1.06,1.37-.39.33-.84.57-1.37.72-.52.15-1.18.22-1.99.22-.51-.02-.9-.04-1.18-.06-.28-.02-.53-.06-.74-.14v-2.11c.29.05.58.1.86.14.28.04.57.06.86.06.56,0,1.02-.08,1.39-.24.36-.16.67-.38.94-.66.27-.28.5-.62.68-1.02.19-.4.39-.84.6-1.33l.89-2.33-8.27-20.63h2.69Z"/><path class="cls-2" d="M223.11,48.71c.43-.88,1.01-1.6,1.74-2.16.73-.56,1.6-.97,2.58-1.24.99-.27,2.09-.4,3.29-.4.91,0,1.82.09,2.73.26.91.17,1.72.5,2.45.98.72.48,1.31,1.16,1.76,2.03.45.87.68,2,.68,3.39v10.99c0,1.02.49,1.53,1.48,1.53.3,0,.56-.05.8-.16v2.12c-.29.05-.56.09-.78.12-.23.03-.52.04-.86.04-.64,0-1.16-.09-1.55-.26-.39-.17-.69-.42-.91-.74-.21-.32-.36-.7-.42-1.14-.07-.44-.1-.93-.1-1.46h-.08c-.45.67-.92,1.26-1.38,1.79-.47.52-.99.96-1.56,1.3-.57.35-1.23.62-1.96.8-.74.19-1.61.28-2.63.28-.96,0-1.86-.11-2.71-.34-.84-.23-1.58-.59-2.2-1.08-.63-.49-1.12-1.12-1.48-1.89-.36-.76-.54-1.67-.54-2.71,0-1.44.32-2.58.96-3.39.64-.82,1.49-1.44,2.54-1.87,1.06-.43,2.25-.73,3.57-.9,1.32-.17,2.66-.34,4.03-.5.54-.05,1-.12,1.4-.2s.74-.22,1-.42c.27-.2.47-.47.62-.82.15-.35.22-.8.22-1.37,0-.86-.14-1.56-.42-2.11-.28-.55-.67-.98-1.16-1.3-.49-.32-1.07-.54-1.72-.66-.65-.12-1.35-.18-2.1-.18-1.6,0-2.91.38-3.92,1.14-1.01.76-1.55,1.99-1.6,3.67h-2.54c.08-1.2.33-2.25.76-3.13M235.73,54.91c-.16.29-.47.51-.92.64-.46.13-.86.23-1.2.28-1.07.19-2.17.36-3.3.5-1.14.15-2.17.37-3.1.66-.94.29-1.7.72-2.3,1.26-.6.55-.9,1.33-.9,2.35,0,.64.13,1.21.38,1.71s.59.92,1.02,1.28c.43.36.92.64,1.48.82.56.19,1.13.28,1.72.28.96,0,1.88-.15,2.76-.44.88-.29,1.65-.72,2.3-1.29.65-.56,1.18-1.24,1.56-2.05.39-.8.58-1.71.58-2.73v-3.29h-.08Z"/><path class="cls-2" d="M118.49,76.66c.89,0,1.58.22,2.08.65.5.44.75,1.03.75,1.79,0,.56-.13,1.06-.39,1.49-.26.43-.67.72-1.24.87v.03c.27.05.49.14.66.26.17.12.3.27.41.44.1.17.17.36.22.57.05.21.08.43.11.65.02.22.03.46.04.69,0,.24.03.46.07.69.04.23.08.44.15.65.07.2.16.38.29.54h-1.38c-.09-.1-.14-.23-.17-.39-.03-.16-.05-.35-.06-.55,0-.21-.02-.42-.02-.66,0-.23-.03-.46-.08-.69-.04-.23-.08-.44-.13-.65-.05-.2-.13-.38-.25-.53-.11-.15-.26-.27-.44-.37-.18-.09-.43-.14-.73-.14h-3.03v3.98h-1.24v-9.32h4.39ZM118.75,80.88c.26-.04.49-.13.68-.25.2-.13.35-.3.47-.51.12-.21.18-.49.18-.83,0-.47-.13-.85-.39-1.15-.26-.29-.68-.44-1.26-.44h-3.08v3.24h2.59c.29,0,.56-.02.82-.07"/><polygon class="cls-2" points="136.5 76.66 136.5 77.7 131.32 77.7 131.32 80.66 136.15 80.66 136.15 81.71 131.32 81.71 131.32 84.93 136.54 84.93 136.54 85.97 130.07 85.97 130.07 76.66 136.5 76.66"/><path class="cls-2" d="M149.75,77.94c-.41-.3-.94-.45-1.58-.45-.26,0-.52.03-.77.08-.25.05-.48.14-.67.26-.2.12-.35.28-.47.49-.12.2-.18.46-.18.76,0,.29.08.52.25.7.17.18.4.32.68.43.28.11.6.21.96.28.36.07.72.16,1.09.24.37.09.73.19,1.09.31.36.12.68.28.96.48.28.2.51.45.68.76.17.31.26.69.26,1.15,0,.5-.11.92-.33,1.27-.22.35-.51.64-.85.86-.35.22-.74.38-1.17.48-.43.1-.86.15-1.29.15-.52,0-1.01-.06-1.48-.2-.46-.13-.87-.33-1.23-.6-.35-.27-.63-.6-.84-1.02-.2-.42-.31-.9-.31-1.47h1.17c0,.39.07.73.23,1.01.15.28.35.51.6.7.25.18.54.32.87.4.33.09.67.13,1.02.13.28,0,.56-.03.84-.08.28-.05.54-.14.76-.27.22-.13.41-.3.55-.51.14-.22.21-.5.21-.83s-.08-.58-.26-.78c-.17-.2-.39-.36-.68-.49-.28-.13-.6-.23-.96-.31-.36-.08-.72-.16-1.09-.24-.37-.08-.73-.18-1.09-.29-.36-.11-.68-.26-.96-.43-.28-.18-.51-.41-.68-.69-.17-.28-.25-.64-.25-1.06,0-.47.1-.88.29-1.22.19-.34.45-.63.76-.85.32-.22.68-.38,1.08-.49.4-.11.82-.16,1.24-.16.48,0,.92.06,1.33.17.41.11.77.29,1.08.54.31.24.55.55.73.92.18.37.28.81.29,1.32h-1.17c-.07-.67-.31-1.16-.72-1.46"/><path class="cls-2" d="M160.33,79.49c.19-.59.47-1.1.84-1.56.37-.45.84-.81,1.39-1.08.56-.27,1.21-.4,1.94-.4s1.39.14,1.94.4c.56.27,1.02.63,1.4,1.08.37.46.65.97.84,1.56.19.59.28,1.2.28,1.83s-.09,1.24-.28,1.83c-.19.59-.47,1.11-.84,1.56-.38.45-.84.81-1.4,1.08-.56.27-1.21.4-1.94.4s-1.39-.13-1.94-.4c-.56-.27-1.02-.62-1.39-1.08-.38-.45-.66-.97-.84-1.56-.19-.59-.28-1.2-.28-1.83s.09-1.24.28-1.83M161.47,82.7c.12.46.31.87.57,1.23.26.36.6.66,1,.88.41.22.9.33,1.46.33s1.05-.11,1.46-.33c.41-.22.74-.51,1-.88.26-.36.45-.77.57-1.23.12-.45.18-.92.18-1.39s-.06-.93-.18-1.39c-.12-.46-.31-.87-.57-1.23-.26-.36-.59-.66-1-.88s-.9-.33-1.46-.33-1.05.11-1.46.33c-.41.22-.74.52-1,.88-.26.36-.45.77-.57,1.23-.12.46-.18.92-.18,1.39s.06.93.18,1.39"/><path class="cls-2" d="M181.9,76.66c.89,0,1.58.22,2.08.65.5.44.75,1.03.75,1.79,0,.56-.13,1.06-.38,1.49-.26.43-.67.72-1.23.87v.03c.27.05.49.14.66.26.17.12.3.27.4.44.1.17.17.36.22.57.05.21.08.43.11.65.02.22.03.46.04.69,0,.24.03.46.06.69.03.23.09.44.15.65.07.2.16.38.29.54h-1.38c-.09-.1-.15-.23-.18-.39-.03-.16-.05-.35-.06-.55,0-.21-.02-.42-.03-.66,0-.23-.04-.46-.08-.69-.03-.23-.08-.44-.13-.65-.05-.2-.13-.38-.25-.53-.11-.15-.26-.27-.44-.37-.18-.09-.43-.14-.73-.14h-3.03v3.98h-1.24v-9.32h4.39ZM182.16,80.88c.26-.04.49-.13.69-.25.19-.13.35-.3.47-.51.12-.21.17-.49.17-.83,0-.47-.13-.85-.39-1.15-.26-.29-.68-.44-1.27-.44h-3.08v3.24h2.59c.29,0,.56-.02.82-.07"/><polygon class="cls-2" points="192.5 77.7 192.5 76.66 199.95 76.66 199.95 77.7 196.84 77.7 196.84 85.97 195.6 85.97 195.6 77.7 192.5 77.7"/><path class="cls-2" d="M224.31,77.98c-.47-.33-1.04-.5-1.69-.5-.56,0-1.03.11-1.43.32-.39.21-.72.49-.98.84-.26.35-.45.75-.57,1.21-.12.45-.18.92-.18,1.41,0,.53.06,1.03.18,1.5.12.48.31.89.57,1.24.26.35.58.63.98.84.4.21.88.31,1.44.31.41,0,.77-.07,1.09-.2.32-.14.59-.32.82-.56.23-.24.41-.52.54-.85.13-.33.21-.69.23-1.07h1.24c-.12,1.17-.53,2.09-1.21,2.74-.69.65-1.63.98-2.82.98-.72,0-1.35-.12-1.89-.37-.54-.25-.99-.59-1.34-1.02-.36-.43-.62-.95-.8-1.54-.18-.59-.27-1.23-.27-1.9s.1-1.31.29-1.91c.19-.59.47-1.11.84-1.56.37-.45.83-.8,1.38-1.05.55-.25,1.18-.39,1.9-.39.49,0,.95.07,1.38.2.43.13.82.32,1.16.58.34.25.62.57.85.95.23.38.37.82.44,1.31h-1.24c-.14-.66-.44-1.15-.92-1.49"/><path class="cls-2" d="M234.8,81.22c.14-.43.35-.8.62-1.12.28-.32.62-.57,1.03-.75.41-.18.88-.27,1.41-.27s1.01.09,1.42.27c.4.18.74.43,1.02.75.28.32.49.69.63,1.12.14.43.21.89.21,1.39s-.07.96-.21,1.38c-.14.43-.35.8-.63,1.12-.28.32-.62.56-1.02.74-.41.18-.88.27-1.42.27s-1-.09-1.41-.27c-.41-.18-.75-.43-1.03-.74-.28-.32-.49-.69-.62-1.12-.14-.42-.21-.89-.21-1.38s.07-.96.21-1.39M235.92,83.7c.11.32.26.58.45.8.19.21.41.38.67.49.26.12.53.17.82.17s.56-.05.81-.17c.26-.11.48-.27.67-.49.19-.21.34-.48.45-.8.11-.32.16-.68.16-1.09s-.05-.77-.16-1.09-.26-.58-.45-.8c-.19-.22-.41-.38-.67-.5-.26-.11-.53-.17-.81-.17s-.56.06-.82.17c-.26.12-.48.28-.67.5-.19.22-.34.48-.45.8s-.16.68-.16,1.09.05.77.16,1.09"/><rect class="cls-2" x="243.43" y="84.52" width="1.45" height="1.45"/><polygon class="cls-1" points="0 0 0 134.41 106.97 134.41 106.97 37.42 31.24 37.42 31.24 102.85 75.43 102.85 75.43 65.42 63.25 65.42 63.25 90.66 43.43 90.66 43.43 49.61 94.78 49.61 94.78 122.22 12.19 122.22 12.19 12.19 252.12 12.19 252.12 0 0 0"/></svg>
        </div>
    
        <div class="loadmeta">
          <div id="loadbar">
            <div class="bar"></div>
          </div>
          <div id="loadtxt"><span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span></div>
        </div>
      </div>
  </Transition>
  </div>
</template>

<style lang="scss" scoped>
.load-enter-active,
.load-leave-active {
  transition: all 1.6s 1s $ease;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
}
.load-enter-from,
.load-leave-to {
  clip-path: polygon(-50% 0, -50% 0, 0 100%, 0 100%);
}

#loading{
  width: 100%;
  height: 100%;
  background: darken($normal, 10%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  @include flex();
  align-items: center;
  justify-content: center;
  .svg{
    width: 14rem;
    margin: 0 0 4rem;
    svg{
      width: 100%;
      display: block;
    }
    .cls-1{fill:#363581;}.cls-2{fill:$white;}
  }
  .loadmeta{
    width: 100%;
    padding: 1.6rem 0;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  #loadbar{
    width: 80%;
    left: 10%;
    height: 1px;
    background: rgba($white,.08);
    position: relative;
    .bar{
      width: 0%;
      height: 100%;
      background: #363581;
      top: 0;
      left: 0;
      position: absolute;
      transition: all 400ms $ease;
      transition-property: width opacity;
    }
  }
  #loadtxt{
    color: $white;
    font-size: .72rem;
    text-align: center;
    text-transform: uppercase;
    margin: 1.6rem 0 0;
    span{
      display: inline-block;
      margin: 0 .4rem 0 0;
      clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);
      animation: loadTxt 800ms $ease alternate infinite;
      @for $i from 1 through 20{
        &:nth-of-type(#{$i}){
          animation-delay: $i * 50ms;
        }
      }
      @keyframes loadTxt {
        0%{
          clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);
        }
        100%{
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
      }
      &:last-of-type{
        margin: 0;
      }
    }
  }
}

</style>

<script>
import * as imagesLoaded from 'imagesloaded'
import { onMounted, ref } from 'vue'

export default {
  setup() {
    const loadend = ref(localStorage.getItem('loaded') === 'true')

    onMounted(() => {
      const video = document.getElementById('fvvideo')
      video.load()
      if (loadend.value) {
        loadCallBack(video)
      } else {
        const pics = document.querySelectorAll('#app img')
        const parsentage = 100 / pics.length
        let counter = 1

        console.log(pics)
        setTimeout(() => {
          pics.forEach((el) => {
            imagesLoaded(el, () => {
              counter += parsentage
              barWidth(counter)
              if (counter >= 100) {
                loadend.value = true
                loadCallBack(video)
                localStorage.setItem('loaded', 'true')
              }
            })
          })
        }, 1000)
      }
    })

    return {
      loadend
    }
  }
}

function barWidth(num) {
  const el = document.querySelector('#loadbar .bar')
  if (el) {
    el.style.width = num + '%'
  }
}

function loadCallBack(video) {
  const fvelem = document.querySelector('.firstview__data')
  if (fvelem) {
    fvelem.classList.add('active')
  }
  video.play()
}
</script>

